import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useCreateRole = (setShowAddForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.CREATE_ROLE],
    (data) => UserService.createRole(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_ROLES);
        setShowAddForm(false)
        toast.success('Role added successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useCreateRole